module.exports = __webpack_public_path__ + "static/media/jogging_icon.5ed118ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jogging_icon.svg
// module id = 157
// module chunks = 0